import { PageManagerConfiguration } from "./PageManager";
import PageManagerConfigurationBase from "./PageManagerConfigurationBase.Generated";

const
    configuration: PageManagerConfiguration = {
        detailsPageMap: {
            ...PageManagerConfigurationBase.detailsPageMap,
        },
        indexPageMap: {
            ...PageManagerConfigurationBase.indexPageMap,
        },
        routes: {
            ...PageManagerConfigurationBase.routes,
        }
    };

export default configuration;